export default __webpack_public_path__ + "img/eTHOsgPX.184899b5.svg";